import VideoItem from './VideoItemSmall';

export default VideoItem;
